import { render, staticRenderFns } from "./PacientesAntecedentesNoPatologicos.vue?vue&type=template&id=3b521d79"
import script from "./PacientesAntecedentesNoPatologicos.vue?vue&type=script&lang=js"
export * from "./PacientesAntecedentesNoPatologicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports